export const modulationContractBalanceCachekeys = {
  one: (user_contract_id: number, queryParams = {}) => [
    'modulation_contract_balance',
    user_contract_id,
    queryParams
  ]
}
